import template from './pagination.html';

const MAX_BUTTONS = 15;
const MIN_BUTTONS = 0;
class PaginationComponent {
  constructor($element, $scope) {
    'ngInject';

    this.$scope = $scope;
    this.element = $element[0];
    this.widths = {
      self: 0,
      counts: 0,
      button: 0,
    };

    this.buttonAmount = MAX_BUTTONS;
    this.countHolder = this.element.getElementsByClassName('count-holder')[0];
    this.resizeObserver = new ResizeObserver(this.onResized.bind(this));
  }

  $onInit() {
    this.resizeObserver.observe(this.element);
    this.resizeObserver.observe(this.countHolder);
  }

  $onDestroy() {
    this.resizeObserver.disconnect;
  }

  onResized(entries) {
    if (!this.widths.button)
      this.widths.button = this.element.getElementsByTagName('li')[0].clientWidth;

    entries.forEach((entry) => {
      if (entry.target === this.element) this.widths.self = entry.contentRect.width;
      else if (entry.target === this.countHolder) this.widths.counts = entry.contentRect.width;
    });

    const width = this.widths.self - this.widths.counts - this.widths.button * 4;
    let buttonAmount = Math.max(
      Math.min(Math.floor(width / this.widths.button), MAX_BUTTONS),
      MIN_BUTTONS,
    );

    if (this.buttonAmount !== buttonAmount) {
      this.$scope.$apply(() => {
        this.buttonAmount = buttonAmount;
      });
    }
  }

  onPageChange() {
    this.onChange(this.currentPage);
  }
}

export default {
  template,
  controller: PaginationComponent,
  controllerAs: 'pagination',
  bindings: {
    total: '<',
    currentPage: '<',
    itemsPerPage: '<',
    onChange: '<',
  },
};
